import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import AppWrapper from './App';
import { bootPwaBackground } from './services/pwaBackground';

bootPwaBackground();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

window.showClaims = async () => {
  const { auth } = await import('./lib/authService');
  const res = await auth.currentUser?.getIdTokenResult(true);
  console.log('claims:', res?.claims);
  return res?.claims;
};
